import React from 'react';
import { Link } from 'react-router-dom';
import { Shuffle, Download, RotateCcw, Menu, X } from 'lucide-react';
import { PRESETS } from '../utils/presets';
import ShareDialog from './ShareDialog';

const TopBar = ({ params, onRandom, onReset, onExportSTL, onExportOBJ, onToggleRotate, isRotating, onPreview, menuOpen, onMenuOpenChange }) => {
  const setMenuOpen = onMenuOpenChange ?? (() => {});

  return (
    <header
      data-testid="topbar"
      className="absolute top-0 left-0 w-full h-16 z-40 flex items-center px-4 md:px-6"
      style={{
        background: 'rgba(6,9,14,0.92)',
        borderBottom: '1px solid rgba(0,240,255,0.12)',
        backdropFilter: 'blur(20px)',
      }}
    >
      {/* Logo */}
      <div className="flex items-center gap-3 mr-2 md:mr-4">
        <div className="flex gap-[3px]">
          <div className="w-[3px] h-5" style={{ background: '#00F0FF', boxShadow: '0 0 8px #00F0FF' }} />
          <div className="w-[3px] h-5 opacity-50" style={{ background: '#00F0FF' }} />
          <div className="w-[3px] h-5 opacity-25" style={{ background: '#00F0FF' }} />
        </div>
        <div>
          <div className="text-[11px] font-mono uppercase tracking-[0.3em] text-white leading-none">Dildo Works</div>
          <div className="text-[8px] font-mono uppercase tracking-[0.25em] text-[#00F0FF]/50 mt-0.5">3D dildo generator</div>
        </div>
      </div>

      {/* Mobile Controls */}
      <div className="ml-auto md:ml-0 md:hidden flex items-center gap-3">
        <button
          onClick={() => { onRandom(); setMenuOpen(false); }}
          className="flex items-center gap-1.5 px-3 py-1.5 text-[9px] uppercase tracking-[0.18em] border border-[#00F0FF]/40 text-[#00F0FF] hover:bg-[#00F0FF]/10 transition-colors"
        >
          <Shuffle size={10} /> Random
        </button>
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="p-2 border border-[#00F0FF]/30 text-[#00F0FF] hover:bg-[#00F0FF]/10 transition-colors"
        >
          {menuOpen ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {/* Nav Content */}
      <div
        className={`absolute top-16 left-0 w-full flex-col p-6 gap-6 border-b border-[#00F0FF]/20 md:static md:flex-row md:border-none md:p-0 flex-1 md:flex md:items-center md:gap-4 md:ml-4 z-50 ${
          menuOpen ? 'flex bg-[#06090e]/95 backdrop-blur-xl' : 'hidden'
        } md:bg-transparent`}
      >
        <div className="flex flex-wrap items-center justify-center md:justify-start gap-2">
          {/* Desktop Random */}
          <button
            onClick={() => { onRandom(); setMenuOpen(false); }}
            className="hidden md:flex items-center gap-1.5 px-3 py-1.5 text-[9px] uppercase tracking-[0.18em] border border-gray-700 text-gray-400 hover:border-[#00F0FF]/50 hover:text-[#00F0FF] transition-all duration-150"
          >
            <Shuffle size={10} /> Random
          </button>
          <ShareDialog params={params} onPreview={onPreview} />
          <button
            onClick={() => { onReset(); setMenuOpen(false); }}
            className="flex items-center gap-1.5 px-3 py-1.5 text-[9px] uppercase tracking-[0.18em] border border-gray-700 text-gray-400 hover:border-gray-500 hover:text-gray-300 transition-all duration-150"
          >
            <RotateCcw size={10} /> Reset
          </button>
          <button
            onClick={() => { onToggleRotate(); setMenuOpen(false); }}
            className={`px-3 py-1.5 text-[9px] uppercase tracking-[0.18em] border transition-all duration-150 font-mono
              ${isRotating
                ? 'border-[#00F0FF]/60 text-[#00F0FF] bg-[#00F0FF]/8'
                : 'border-gray-700 text-gray-500 hover:border-gray-500'
              }`}
          >
            Auto-Rotate
          </button>
        </div>

        <div className="hidden md:block flex-1" />

        <Link
          to="/about"
          onClick={() => setMenuOpen(false)}
          className="flex items-center justify-center md:justify-start px-3 py-1 md:py-1.5 text-[9px] uppercase tracking-[0.18em] text-gray-500 hover:text-gray-300 transition-colors"
        >
          About
        </Link>

        <div className="flex items-center justify-center md:justify-end gap-2 mt-4 md:mt-0">
          <button
            onClick={() => { onExportOBJ(); setMenuOpen(false); }}
            className="flex items-center gap-1.5 px-4 py-1.5 text-[9px] uppercase tracking-[0.18em] border border-[#00F0FF]/25 text-[#00F0FF]/70 hover:border-[#00F0FF]/60 hover:text-[#00F0FF] transition-all duration-150"
          >
            <Download size={10} /> .OBJ
          </button>
          <button
            onClick={() => { onExportSTL(); setMenuOpen(false); }}
            className="flex items-center gap-1.5 px-4 py-1.5 text-[9px] uppercase tracking-[0.18em] border border-[#00F0FF]/25 text-[#00F0FF]/70 hover:border-[#00F0FF]/60 hover:text-[#00F0FF] transition-all duration-150"
          >
            <Download size={10} /> .STL
          </button>
        </div>
      </div>
    </header>
  );
};

export default TopBar;
